import axios from "axios";

export interface ChecklistWriteTargets {
    organization_id?: number | null;
    organization_group_id?: number | null;
    draft_publication_group_id?: number | null;
}

export type ChecklistWriteErrorClassification =
    | {
          kind: "group_refused" | "organization_refused";
          status: 422;
          detail: string;
          targetId: number;
      }
    | {
          kind: "validation";
          status: 400 | 422;
          detail: string | null;
      }
    | {
          kind: "conflict";
          status: 409;
          detail: string | null;
      }
    | {
          kind: "client" | "failed";
          status: number | null;
          detail: string | null;
      };

export const classifyChecklistWriteError = (
    error: unknown,
    sent: ChecklistWriteTargets = {}
): ChecklistWriteErrorClassification => {
    const response = axios.isAxiosError(error) ? error.response : undefined;
    const status = response?.status ?? null;
    const body: unknown = response?.data;
    const rawDetail =
        body && typeof body === "object"
            ? (body as { detail?: unknown }).detail
            : undefined;
    const detail = typeof rawDetail === "string" ? rawDetail : null;

    if (status === 422 && detail !== null) {
        const targets: {
            kind: "organization_refused" | "group_refused";
            id: number | null | undefined;
        }[] = [
            { kind: "organization_refused", id: sent.organization_id },
            { kind: "group_refused", id: sent.organization_group_id },
            { kind: "group_refused", id: sent.draft_publication_group_id },
        ];
        const sentTargets = targets.filter((target) => target.id !== undefined);
        if (sentTargets.length === 1 && typeof sentTargets[0].id === "number") {
            return {
                kind: sentTargets[0].kind,
                status,
                detail,
                targetId: sentTargets[0].id,
            };
        }
    }

    if (status === 400 || status === 422) {
        return { kind: "validation", status, detail };
    }
    if (status === 409) {
        return { kind: "conflict", status, detail };
    }
    if (status !== null && status >= 400 && status < 500) {
        return { kind: "client", status, detail };
    }
    return { kind: "failed", status, detail };
};
